import type { OverviewFeatureConfig } from './type';

export const overview: OverviewFeatureConfig = {
    birthdayGreeting: {
        isGeneralConsentRequired: false,
        isMarketingConsentRequired: false,
    },
    products: {
        currentAccount: {
            secondaryAmount: 'balance',
        },
        buildingSociety: {
            saving: {
                showMonthlyContribution: false,
                showProgress: false,
                showTargetAmount: false,
            },
        },
    },
    tour: {
        version: 2,
    },
};
